export const PRESETS_SET = 'PRESETS_SET';
export const presetsSet = (data) => ({ type: PRESETS_SET, payload: data });
